import { createCodeScannerState } from '@cli-utils/js-source-scan.js'
import { advanceTopLevelScanner } from './advance-top-level-scanner.js'

export function findTopLevelValueEnd(
  content: string,
  valueStart: number,
  objectEnd: number
): number {
  let depth = 0
  const scannerState = createCodeScannerState()

  for (let i = valueStart; i < objectEnd; i++) {
    const scanResult = advanceTopLevelScanner(content, i, scannerState, depth)
    depth = scanResult.depth
    if (scanResult.skip) {
      i = scanResult.nextIndex
      continue
    }

    if (scanResult.char === ',') {
      return i
    }
  }

  return objectEnd
}
